import { useEffect, useRef, useState } from "react";
import { AutoSizer } from "react-virtualized";
import { IMAGES_PANEL_MASONRY_GAPS } from "../../constants";
import { useImagesPanelStockStore } from "../../store";
import { ImagesPanelStockMasonryColumn } from "./stock-masonry-column";

const GAPS = IMAGES_PANEL_MASONRY_GAPS;

interface IProps {
  searchQuery: string;
  loadMoreImages: () => void;
}

export const ImagesPanelStockMasonry = ({
  searchQuery,
  loadMoreImages,
}: IProps) => {
  const columnsData = useImagesPanelStockStore((s) => s.columnsData);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    const containerEl = containerRef.current;
    if (!containerEl) return;
  }, [searchQuery]);

  return (
    <div
      ref={containerRef}
      className="scrollbar tw-mt-3 tw-size-full tw-w-[calc(100%-6px)] tw-overflow-y-scroll tw-overscroll-contain tw-pl-6 tw-pr-3 tw-pt-1 -sm:tw-pl-3 -sm:tw-pr-2"
      onScroll={(e) => {
        setScrollTop(e.currentTarget.scrollTop);
      }}
    >
      <AutoSizer>
        {({ width, height }) => (
          <div
            className="tw-grid tw-grid-flow-col tw-content-start"
            style={{ width, columnGap: GAPS }}
          >
            {columnsData.map((col, colIdx) => (
              <ImagesPanelStockMasonryColumn
                key={colIdx}
                onLoadMore={colIdx === 0 ? loadMoreImages : undefined}
                colIdx={colIdx}
                images={col}
                scrollTop={scrollTop}
                colWidth={
                  (width - GAPS * (columnsData.length - 1)) / columnsData.length
                }
                height={height}
              />
            ))}
          </div>
        )}
      </AutoSizer>
    </div>
  );
};
